import React from 'react';
import { Option, Select, SimpleSelectProps } from 'carbon-react/lib/components/select';

import { useIntl } from '@futrli/localisation';

export const DecimalPlacesMenu = (props: Omit<SimpleSelectProps, 'children'>) => {
  const intl = useIntl();

  const options = Array.from({ length: 7 }).map((_, i) => ({
    id: `${i}`,
    name: intl.formatNumber(0, { minimumFractionDigits: i, maximumFractionDigits: i })
  }));

  return (
    <Select
      autoComplete="off"
      label={intl.formatMessage({
        id: 'predict.decimal_display',
        defaultMessage: 'Decimal display'
      })}
      mb={0}
      size="large"
      {...props}
    >
      {options.map(o => (
        <Option key={o.id} value={o.id} text={o.name} />
      ))}
    </Select>
  );
};
